export const actionTypes = {
    CHAGE: 'CHANGE_ALERT'
}

export const changeAlert = (payLoad) =>({
    type: actionTypes.CHAGE,
    payLoad
})